/**
 * Toast policy (ux/01 §3.9) — pure helpers shared by the ToastProvider and the
 * single App-level ToastHost. Values come from config/ui.config.js.
 */
import {
  TOAST_ALERT_TONES,
  TOAST_LIFETIME_MS,
  TOAST_MAX_VISIBLE,
} from "../config/ui.config.js";

export const TOAST_TONES = Object.freeze(Object.keys(TOAST_LIFETIME_MS));

/** Unknown types are shown as info. */
export function normalizeToastType(type) {
  return TOAST_TONES.includes(type) ? type : "info";
}

/**
 * Effective lifetime in ms (0 = persistent until dismissed). Errors and
 * loading toasts are always persistent; an explicit `0` makes any toast
 * persistent; otherwise the tone lifetime is a floor.
 */
export function resolveToastLifetime(type, requested) {
  const t = normalizeToastType(type);
  const base = TOAST_LIFETIME_MS[t];
  if (base === 0 || requested === 0) return 0;
  const r = Number(requested);
  return Number.isFinite(r) && r > base ? r : base;
}

/** ARIA role of a toast: warnings and errors interrupt, the rest wait. */
export function toastRole(type) {
  return TOAST_ALERT_TONES.includes(normalizeToastType(type)) ? "alert" : "status";
}

/** The toasts actually drawn: the newest TOAST_MAX_VISIBLE, oldest on top. */
export function visibleToasts(toasts) {
  const list = Array.isArray(toasts) ? toasts : [];
  return list.slice(Math.max(0, list.length - TOAST_MAX_VISIBLE));
}
